import { size } from '@styles/theme'
import styled from '@emotion/styled'
import { ButtonBase } from '@mui/material'
import { PiGearSix } from 'react-icons/pi'

const StyledIconButton = styled(ButtonBase)`
  height: ${size(3)};
  width: ${size(3)};
  padding: 0;
  border-radius: 100%;
`

const GearIconButton = ({ iconProps, ...rest }) => (
  <StyledIconButton {...rest}>
    <PiGearSix
      color='white'
      size={size(3)}
      {...iconProps}
    />
  </StyledIconButton>
)


export default GearIconButton
